<div class="navbar-container">
    <!-- Logo sezione -->
    <div class="navbar-logo">
        <a (click)="goToHome()" style="cursor: pointer;">
            <img src="assets/loghi/logo_pmo2.png" alt="Logo PMO2" height="40" style="margin-right: 10px;">
        </a>
        <!-- Indicatore ambiente di test -->
        <div *ngIf="isTestEnvironment" class="test-environment-indicator">
            <span class="test-badge">TEST</span>
        </div>
       <!--  <span class="version-badge">v{{ appVersion }}</span> -->
    </div>

    <!-- Menu di navigazione -->
    <div class="navbar-navigation" *ngIf="isLoggedIn">
        <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">

            <li>
                <a (click)="goToRichieste()" [class.active]="isActiveRoute('richieste')">
                    <span class="material-icons nav-icon">dashboard</span>
                    <span>Richieste</span>
                </a>
            </li>
            <li>
              <a (click)="goToInterventi()" [class.active]="isActiveRoute('interventi')">
                  <span class="material-icons nav-icon">construction</span>
                  <span>Interventi</span>
              </a>
            </li>
            <li>
              <a (click)="goToSchede()" [class.active]="isActiveRoute('schede')">
                  <i class="pi pi-map"></i>
                  <span>Schede</span>
              </a>
          </li>

          <li *ngIf="isSuperAdmin || isAdmin || navbarChip === 'UMVS'" class="lg:relative">
            <a class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                style="z-index: 9999;"
                [class.active]="isActiveRoute('configurazione')"
                (click)="openConfigPanel($event)">
                <i class="pi pi-cog"></i>
                <span>Configurazione</span>
                <span style="width: 10px; display: inline-block;"></span>
                <i class="pi" [ngClass]="hideConfigMenu ? 'pi-angle-down' : 'pi-angle-up'"></i>
            </a>
            <div *ngIf="!hideConfigMenu" class="config-dropdown">
              <ul class="list-none p-0 m-0">
               <!--  <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150">
                    <i class="pi pi-warehouse mr-2"></i>
                    <span>Enti Esecutori</span>
                  </a>
                </li> -->
                <!-- <li class="relative">
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150 cursor-pointer" (click)="toggleSubMenu($event)">
                    <i class="pi pi-arrow-circle-down mr-2"></i>
                    <span>Scarica</span>
                  </a>
                </li> -->
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="scaricaProgettoQGIS()">
                    <i class="pi pi-download mr-2"></i>
                    <span style="font-size: 0.8rem;">Scarica Progetto QGIS</span>
                  </a>
                </li>
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="goToUtenti()">
                    <i class="pi pi-user mr-2"></i>
                    <span style="font-size: 0.8rem;">Utenti</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="lg:relative" >
            <a class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                style="z-index: 9999;"
                (click)="openHelpPanel($event)">
                <i class="pi pi-question-circle"></i>
                <span>Aiuto</span>
                <span style="width: 10px; display: inline-block;"></span>
                <i class="pi" [ngClass]="hideHelpMenu ? 'pi-angle-down' : 'pi-angle-up'"></i>
            </a>
            <div *ngIf="!hideHelpMenu" class="config-dropdown">
              <ul class="list-none p-0 m-0">
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="goToFaq()" pTooltip="Apri la pagina FAQ" tooltipPosition="top">
                    <i class="pi pi-question-circle mr-2"></i>
                    <span style="font-size: 0.8rem;">FAQ</span>
                  </a>
                </li>
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="scaricaManuale()" pTooltip="Scarica il manuale" tooltipPosition="top">
                    <i class="pi pi-book mr-2"></i>
                    <span style="font-size: 0.8rem;">Manuale</span>
                  </a>
                </li>
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="scaricaSinotticoSchede()" pTooltip="Scarica il sinottico delle schede" tooltipPosition="top">
                    <i class="pi pi-download mr-2"></i>
                    <span style="font-size: 0.8rem;">Sinottico schede</span>
                  </a>
                </li>
                <li>
                  <a class="flex align-items-center text-600 hover:text-900 transition-colors transition-duration-150"
                    (click)="openSupportModal()" pTooltip="Contatta il supporto" tooltipPosition="top">
                    <i class="pi pi-envelope mr-2"></i>
                    <span style="font-size: 0.8rem;">Supporto</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
    </div>

    <!-- Sezione utente -->
    <div class="navbar-user">
        <p-chip *ngIf="!hideChip" styleClass="mr-2">
            <span [style.color]="chipColor">{{navbarChip}}</span>
        </p-chip>

        <button *ngIf="(auth.isAuthenticated$ | async) === false"
                pButton
                class="p-button-text"
                (click)="loginWithRedirect()">
            <i class="pi pi-sign-in text-2xl mr-2" style="font-size: 1.2rem;"></i>
        <!--     <span>Login</span> -->
        </button>

        <button *ngIf="auth.user$ | async as user"
                pButton
                class="p-button-text"
                (click)="logout()">
                <i class="pi pi-sign-out text-base lg:text-2xl mr-2 lg:mr-0"></i>
                <!-- <span class="block lg:hidden font-medium">Logout</span> -->
        </button>
    </div>
</div>

<style>
.submenu {
  top: 100%;
  left: 0;
  display: none;
}

.submenu.hidden {
  display: none;
}

.submenu:not(.hidden) {
  display: block;
}
</style>

<app-support-modal></app-support-modal>
<p-toast></p-toast>
